import { Dictionary } from '../../utils/types'

export enum GtmEventType {
  Login = 'login',
  AddToCart = 'add_to_cart',
  Purchase = 'purchase'
}

type GtmEventBase<T, D = {}> = { event: T | null } & D

export type TransactionProduct = {
  ['item_id']: string // insert dynamic value including product information {{EntityIdentifier}}_{{ReportName}}
  ['item_name']: string // insert dynamic value including product information {{CompanyName}}_{{ReportName}}
  price: number // insert report price (VAT included). Use dot as decimal separator.
  quantity: number // insert quantity in terms of number of the same SKU purchased
}

export type GtmEvent =
  | GtmEventBase<GtmEventType.Login>
  | GtmEventBase<
      GtmEventType.AddToCart,
      {
        items: TransactionProduct[]
        currency: string
        value: number
        itemNumber: number | undefined
        button: string | undefined
      }
    >
  | GtmEventBase<
      GtmEventType.Purchase,
      {
        ecommerce: {
          ['transaction_id']: string //insert OrderID
          value: number //insert total value of the transaction (VAT included). Use dot as decimal separator.
          currency: string
          items: TransactionProduct[]
        }
      }
    >
  | {
      ecommerce: null
    }

export type GtmState = {
  purchases: Dictionary<Date>
}
